import { QueryAuditEventsArgs } from '@api/gql/graphql';
import { graphql } from '@api/gql';
import { QuerieKeys } from '@api/gql-queries/querieKeys';
import { useInfiniteQuery } from '@tanstack/react-query';

const AuditEventsQuery = graphql(`
  query AuditEvents($pagination: PaginationInput, $filter: AuditEventsFilterInput) {
    auditEvents(pagination: $pagination, filter: $filter) {
      totalCount
      edges {
        node {
          id
          user {
            id
            email
            firstName
            lastName
          }
          integration {
            id
            name
            type
            typeDisplayName
            icons {
              svg
            }
          }
          eventType
          action
          target
          timestamp
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`);

const dummyData = {
  totalCount: 50,
  edges: [
    {
      node: {
        id: '51f5dfe9-d07c-47ac-81ae-ffce1c801626',
        user: {
          id: 'fa59812a-de6f-49cb-a8a4-40e5da224740',
          email: 'angelaflores@yahoo.com',
          firstName: 'Angela',
          lastName: 'Watkins',
        },
        integration: {
          id: 'ac15f038-4a38-4266-ba58-939c73b2beed',
          name: 'S3 Bucket',
          type: 'WEB',
          typeDisplayName: 'S3 Bucket',
          icons: {
            svg: 'https://slack-cdn.apono.io/integrations/aws-s3.svg',
          },
        },
        eventType: 'DROP DB',
        action: 'Very bad action',
        target: 'Yasmin',
        timestamp: '1712149013.940466',
      },
      cursor: '317ffbb6-ad52-46d0-bf34-8b299712fa3d',
    },
    {
      node: {
        id: 'a1d4f2f5-0673-4a72-8774-9b449dd7f4a7',
        user: {
          id: '52ac77d6-6aea-4abb-892e-43470f8f766e',
          email: 'odomrichard@bradford-carrillo.com',
          firstName: 'Justin',
          lastName: 'Brown',
        },
        integration: {
          id: '2e1a2972-57a5-4afa-a434-0a9f3f385711',
          name: 'Kubernetes',
          type: 'WEB',
          typeDisplayName: 'Kubernetes',
          icons: {
            svg: 'https://slack-cdn.apono.io/integrations/kubernetes.svg',
          },
        },
        eventType: 'LOGIN_ATTEMPT',
        action: 'Attempted Login',
        target: 'Flaysh',
        timestamp: '1712149013.940466',
      },
      cursor: '6b5b695c-0454-4383-9e13-b7998f938ba1',
    },
    {
      node: {
        id: '157d3ec8-6a68-444f-bd83-b809593aa8df',
        user: {
          id: '37c9be0e-8a61-4646-b4cf-6f139362fbe1',
          email: 'stevenkelley@richardson.com',
          firstName: 'Linda',
          lastName: 'Smith',
        },
        integration: {
          id: '16d942cb-f5f0-486d-b6f1-b6b070ab91a5',
          name: 'Postgres',
          type: 'WEB',
          typeDisplayName: 'Database',
          icons: {
            svg: 'https://slack-cdn.apono.io/integrations/postgres.svg',
          },
        },
        eventType: 'LOGOUT',
        action: 'Attempted Logout',
        target: 'Dima G.',
        timestamp: '1712149013.940466',
      },
      cursor: '97e49383-8c76-4217-90fb-ee7006527150',
    },
  ],
  pageInfo: {
    hasNextPage: true,
    hasPreviousPage: false,
    endCursor: 'someEndCursor',
    startCursor: 'someStartCursor',
  },
};

export const useListAuditEvents = (variables?: QueryAuditEventsArgs) => {
  return useInfiniteQuery(
    [QuerieKeys.AUDIT_EVENT, variables],
    async ({ pageParam = 0 }) => {
      const data = dummyData.edges[pageParam] ? [dummyData.edges[pageParam]] : [];
      const hasNextPage = pageParam < dummyData.edges.length - 1;
      const hasPreviousPage = pageParam > 0;

      return Promise.resolve({
        data,
        pagination: {
          nextPageCursor: hasNextPage ? Number(pageParam) + 1 : undefined,
          prevPageCursor: hasPreviousPage ? pageParam - 1 : undefined,
        },
      });
    },
    {
      getNextPageParam: (lastPage) => lastPage.pagination.nextPageCursor,
      getPreviousPageParam: (firstPage) => firstPage.pagination.prevPageCursor,
    },
  );
};
